import React from 'react';
import Navigation from '../components/Navigation';
import HeroSection from '../components/HeroSection';
import IntroSection from '../components/IntroSection';
import ThreeStepsSection from '../components/ThreeStepsSection';
import PresetsSection from '../components/PresetsSection';
import BenefitsSectionPremium from '../components/BenefitsSectionPremium';
import TechnologyHighlight from '../components/TechnologyHighlight';
import ExosomeSection from '../components/ExosomeSection';
import ClinicValueSection from '../components/ClinicValueSection';
import ProductsSection from '../components/ProductsSection';
import FinalCTAPremium from '../components/FinalCTAPremium';
import Footer from '../components/Footer';
import SEOHelmet from '../components/SEOHelmet';

const Home = () => {
  return (
    <div className="min-h-screen bg-white">
      <SEOHelmet 
        title="MCT System - Advanced Photothermal Biomodulation for Regenerative Medicine"
        description="Meta Cell Technology offers cutting-edge photothermal biomodulation technology to enhance PRP, exosome therapy, and regenerative aesthetics. Achieve superior skin rejuvenation and anti-aging treatment results."
        keywords="PRP technology, exosome therapy, regenerative aesthetics, skin rejuvenation, anti-aging treatments, photothermal biomodulation, platelet-rich plasma, MCT system"
      />
      
      <Navigation />
      <HeroSection />
      <ThreeStepsSection />
      <IntroSection />
      <PresetsSection />
      <BenefitsSectionPremium />
      <TechnologyHighlight />
      <ExosomeSection />
      <ClinicValueSection />
      <ProductsSection />
      <FinalCTAPremium />
      <Footer />
    </div>
  );
};

export default Home;